import React, { Component } from 'react';
import { connect } from 'react-redux';
import UsersTable from './UsersTable';
import userService from '../../api/userService';
import NewAdministratorForm from './NewAdministratorForm';
import { CircularProgress, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { Edit } from '@material-ui/icons';

class UsersScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            showDeleteConfirmation: false,
            loadingData: true,
            couponsAmount: 5
        }
        this.showForm = this.showForm.bind(this);
        this.hideForm = this.hideForm.bind(this);
        this.changeCouponAmount = this.changeCouponAmount.bind(this);
    }

    componentDidMount() {
        userService.getCouponsAmount()
            .then(couponsAmount => {
                this.setState({
                    couponsAmount
                })
            });
        userService.getAllUsers()
            .then(() => {
                this.setState({
                    loadingData: false
                });
            });


    }

    changeCouponAmount({ target }) {
        const couponsAmount = parseInt(target.value);
        this.setState({
            couponsAmount: isNaN(couponsAmount) ? 0 : couponsAmount
        });
    }

    showForm() {
        this.setState({
            showForm: true
        });
    }

    hideForm() {
        this.setState({
            showForm: false
        });
    }

    showDeleteConfirmation() {
        this.setState({
            showDeleteConfirmation: true
        });
    }

    hideDeleteConfirmation() {
        this.setState({
            showDeleteConfirmation: false
        });
    }

    render() {
        if (this.state.loadingData) {
            return (
                <div style={{ display: 'flex', flex: 1, flexGrow: 1, height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress color="secondary" />
                </div>
            );
        }

        return (
            <div>
                <TextField
                    autoFocus
                    variant="outlined"
                    margin="normal"
                    id="name"
                    label="Coupon's amount"
                    type="text"
                    helperText="This will define the amount of coupons users will receive upon signing up."
                    onChange={this.changeCouponAmount}
                    value={this.state.couponsAmount}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => {
                                    userService.setCouponsAmount(this.state.couponsAmount);
                                }}>
                                    <Edit />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                    fullWidth
                />
                <UsersTable users={this.props.users}
                    addUser={this.showForm}
                    deleteUser={this.showDeleteConfirmation} />
                <NewAdministratorForm showModal={this.state.showForm} hideForm={this.hideForm} />
            </div>
        );
    }
}

const mapStateToProps = store => ({
    users: store.userState.users
});

export default connect(mapStateToProps)(UsersScreen);